import React, { useState, useContext, useCallback, useEffect } from "react"
import { useChampionContext } from "./ChampionContext"
import { usePrevious } from "../utils/usePrevious"
import { isSmallViewport } from "../constants"

const DrawerContext = React.createContext(null)

export const DrawerContextProvider = ({ children }) => {
  const { focus } = useChampionContext()
  // on phones the drawer is a full overlay, so start it closed there
  const [open, setOpen] = useState(() => !isSmallViewport())
  const toggle = useCallback(() => setOpen((b) => !b), [])

  // reopen drawer after selecting a champion lineup —
  // except on phones, where the user wants to see the cards
  const prevFocus = usePrevious(focus)
  useEffect(() => {
    if (!prevFocus && focus && !isSmallViewport()) {
      setOpen(true)
    }
  }, [prevFocus, focus])

  return (
    <DrawerContext.Provider
      value={{
        open,
        setOpen,
        toggle,
      }}
    >
      {children}
    </DrawerContext.Provider>
  )
}

export const useDrawerContext = () => {
  const value = useContext(DrawerContext)
  if (!value) {
    throw new Error("Called useDrawerContext() outside of provider")
  }
  return value
}
